import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchKeySellingPoints } from './utilities/fetch-key-selling-points';
var ProductKeySellingPointsDirectiveController = /** @class */ (function (_super) {
    __extends(ProductKeySellingPointsDirectiveController, _super);
    function ProductKeySellingPointsDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductKeySellingPointsDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductKeySellingPointsDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        this.transclude();
        this.$q.when(fetchKeySellingPoints(productId, this.$scope.pType, this.$scope.mode))
            .then(function (keySellingPoints) {
            _this.$scope.keySellingPoints = keySellingPoints || [];
        });
    };
    ProductKeySellingPointsDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductKeySellingPointsDirectiveController;
}(ProductDirectiveBaseController));
export var ProductKeySellingPointsDirective = [
    function () {
        return {
            controller: ProductKeySellingPointsDirectiveController,
            restrict: 'E',
            scope: {
                pId: '<',
                pType: '@',
                mode: '@?'
            },
            transclude: true,
        };
    },
];
